import { useAuthMutation } from '#lib/hooks/use-mutation.js';
import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';

async function postItineraryOrder(data, authHeaders) {
    const response = await fetchAndParse(`${API_URL}/p/import`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(data)
    });
    return await response;
}

async function postItineraryClone(data, authHeaders) {
    const response = await fetchAndParse(`${API_URL}/p/itinerary/clone`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(data)
    });
    return await response;
}

export default function useCreateItinerary(options) {
    return useAuthMutation({
        mutationFn: (data, authHeaders) => postItineraryOrder(data, authHeaders),
        ...options
    });
}

export function useCloneItinerary(options) {
    return useAuthMutation({
        mutationFn: (data, authHeaders) => postItineraryClone(data, authHeaders),
        ...options
    });
}
